// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/Login/background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ForgotpassRowMain{
    display: flex;
   
}
.forgotPasswordImg{
    height: 80vh !important;
    width:35vw;
    -webkit-backdrop-filter: blur(85px) !important;
            backdrop-filter: blur(85px) !important;
    opacity: 0.7 !important;
}
.Forgotpass {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    /* transform: rotate(180deg); */
}
.forgotdiv{
    border: 2px solid #00000017;
    padding: 15px;
    border-radius: 5px;
    margin-top: 9rem;
    -webkit-backdrop-filter: blur(20px);
            backdrop-filter: blur(20px);
    opacity: 1.9;
    align-items: center;
    height: 80%;
    width: 140%;
 
}
.forgotinputLabel{
    margin-top: 15px;
    
}
.forgotInput{
    background: #FFFFFF;
    border: 1px solid #CDCDCD;
    border-radius: 5px;
    height: 50px;
    width: 100%;
    margin-top: 10px;
}
.ForgotButton{
    background:  #33b249 !important;
    margin-left: 130px;
    /* margin-right: 50px; */
    height: 42px;
    border-radius: 6px;
    width: 150px !important;
font-weight: 500;
margin-bottom: 20px;
color: white !important;

}
.SubmitButton1{
    margin-Top: 50px;
    /* margin-right: 58px; */
}
.requiredspan{
    color: red;
}
.forgotChangeInput{
    margin-top: 35px;
    background: #FFFFFF;
    border: 1px solid #CDCDCD;
    border-radius: 5px;
    height: 50px;
    width: 100%;
}
.changeforgot{
    width: 400px !important;

}
.changeforgot h3{
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/Components/ForgotPassword/ForgotPassword.css"],"names":[],"mappings":"AAAA;IACI,aAAa;;AAEjB;AACA;IACI,uBAAuB;IACvB,UAAU;IACV,8CAAsC;YAAtC,sCAAsC;IACtC,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yDAAqD;IACrD,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,+BAA+B;AACnC;AACA;IACI,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,mCAA2B;YAA3B,2BAA2B;IAC3B,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,WAAW;;AAEf;AACA;IACI,gBAAgB;;AAEpB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;AAC3B,gBAAgB;AAChB,mBAAmB;AACnB,uBAAuB;;AAEvB;AACA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;AACA;IACI,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;AACA;IACI,uBAAuB;;AAE3B;AACA;IACI,kBAAkB;AACtB","sourcesContent":[".ForgotpassRowMain{\r\n    display: flex;\r\n   \r\n}\r\n.forgotPasswordImg{\r\n    height: 80vh !important;\r\n    width:35vw;\r\n    backdrop-filter: blur(85px) !important;\r\n    opacity: 0.7 !important;\r\n}\r\n.Forgotpass {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-image: url('/public/Login/background.jpg');\r\n    background-size: cover;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    /* transform: rotate(180deg); */\r\n}\r\n.forgotdiv{\r\n    border: 2px solid #00000017;\r\n    padding: 15px;\r\n    border-radius: 5px;\r\n    margin-top: 9rem;\r\n    backdrop-filter: blur(20px);\r\n    opacity: 1.9;\r\n    align-items: center;\r\n    height: 80%;\r\n    width: 140%;\r\n \r\n}\r\n.forgotinputLabel{\r\n    margin-top: 15px;\r\n    \r\n}\r\n.forgotInput{\r\n    background: #FFFFFF;\r\n    border: 1px solid #CDCDCD;\r\n    border-radius: 5px;\r\n    height: 50px;\r\n    width: 100%;\r\n    margin-top: 10px;\r\n}\r\n.ForgotButton{\r\n    background:  #33b249 !important;\r\n    margin-left: 130px;\r\n    /* margin-right: 50px; */\r\n    height: 42px;\r\n    border-radius: 6px;\r\n    width: 150px !important;\r\nfont-weight: 500;\r\nmargin-bottom: 20px;\r\ncolor: white !important;\r\n\r\n}\r\n.SubmitButton1{\r\n    margin-Top: 50px;\r\n    /* margin-right: 58px; */\r\n}\r\n.requiredspan{\r\n    color: red;\r\n}\r\n.forgotChangeInput{\r\n    margin-top: 35px;\r\n    background: #FFFFFF;\r\n    border: 1px solid #CDCDCD;\r\n    border-radius: 5px;\r\n    height: 50px;\r\n    width: 100%;\r\n}\r\n.changeforgot{\r\n    width: 400px !important;\r\n\r\n}\r\n.changeforgot h3{\r\n    text-align: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
